import React, { ReactNode } from 'react';

import RichText from '../static-pages/wagtail/RichText/RichText';
import css from './Section.module.css';

const Section = ({
  id,
  html,
  title,
  children,
}: {
  id: string;
  html: string;
  title: string;
  children?: ReactNode;
}) => (
  <section className={css.section} id={id}>
    <h2 className="mb-4 highlight autoType800">{title}</h2>
    {html && <RichText content={html} tag="div" />}
    {children}
  </section>
);

export default Section;
